import { Api_Video_Type } from '@core/api';
import { getVideoPosterByType } from '@core/helpers/video';
import { GATED_OVERLAY_POSTER_IMG, GATED_OVERLAY_TRAILER_SOURCE, GATED_OVERLAY_VIDEO, } from '@player/testIds';
import { GatePosterImg, GatePosterVideo, PosterOverlay, } from './GateOverlay.styles';
/**
 * The gate poster shows the poster image for short video, or the trailer for livestreams
 */
export const GatePoster = ({ video }) => {
    if (!video) {
        return null;
    }
    const animatedPoster = video ? getVideoPosterByType(video, 'animated') : null;
    const staticPoster = video ? getVideoPosterByType(video, 'static') : null;
    if (video.video_type === Api_Video_Type.LIVESTREAM &&
        video.video_sources?.length) {
        return (<>
        <GatePosterVideo autoPlay data-testid={GATED_OVERLAY_VIDEO} muted playsInline>
          <source src={video.video_sources[0].src} type={video.video_sources[0].type} data-testid={GATED_OVERLAY_TRAILER_SOURCE}/>
        </GatePosterVideo>
        <PosterOverlay />
      </>);
    }
    return (<>
      <GatePosterImg src={animatedPoster ? animatedPoster.url : staticPoster?.url} aria-hidden="true" alt="" data-testid={GATED_OVERLAY_POSTER_IMG}/>
      <PosterOverlay />
    </>);
};
